import React from 'react';
import { QuickActionsRow } from './QuickActionsRow';
import type { HomeBusiness, HomeActions } from '../../model/types';

interface Props {
  business: HomeBusiness;
  actions: HomeActions;
}

export const BusinessInfoSection: React.FC<Props> = ({ business, actions }) => {
  const hasContact = actions.canCall || actions.canOpenMap;

  if (!hasContact) return null;

  return (
    <div style={{ position: 'relative' }}>
      <QuickActionsRow business={business} actions={actions} />
    </div>
  );
};
